import {
    REQUEST_CLIENT_TOKEN_SUCCESS,
    REQUEST_CLIENT_TOKEN_ERROR,
    REQUEST_CHANNEL_DATA_SUCCESS,
    REQUEST_CHANNEL_DATA_ERROR,
    DEV_PHONE_CONFIG_ERROR,
    CONFIGURE_NUMBER_IN_USE,
    UPDATE_CALL_INFORMATION,
    UPDATE_MUTE_STATUS,
    SET_DESTINATION_NUMBER,
    ADD_DIGIT_TO_DESTINATION_NUMBER
} from '../actions/types'

const initialState = {
    currentCallInfo: null,
    channelData: {},
    destinationNumber: '+19714598531',
    numberInUse: {
        phoneNumber: '',
    },
    twilioAccessToken: '',
    voiceDevice: {},
    isMuted: false,
    error: {}
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case CONFIGURE_NUMBER_IN_USE:
            return { ...state, numberInUse: action.number }
        case DEV_PHONE_CONFIG_ERROR:
            return { ...state, error: action.error }
        case REQUEST_CLIENT_TOKEN_SUCCESS:
            return { ...state, twilioAccessToken: action.payload }
        case REQUEST_CLIENT_TOKEN_ERROR:
            return { ...state, error: action.error }
        case REQUEST_CHANNEL_DATA_SUCCESS:
            return { ...state, channelData: action.payload }
        case REQUEST_CHANNEL_DATA_ERROR:
            return { ...state, error: action.error }
        case SET_DESTINATION_NUMBER:
            return { ...state, destinationNumber: action.number }
        case UPDATE_CALL_INFORMATION:
            return { ...state, currentCallInfo: action.call ? { ...state.currentCallInfo, ...action.call } : null }
        case UPDATE_MUTE_STATUS:
            return {
                ...state,
                isMuted: action.isMuted
            }
        case ADD_DIGIT_TO_DESTINATION_NUMBER:
            return { ...state, destinationNumber: state.destinationNumber + action.digit }
        default:
            return state
    }
}
